import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';

const PaymentSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/billing?credits=success', { replace: true });
  }, [navigate]);

  return (
    <Box 
      display="flex" 
      flexDirection="column" 
      alignItems="center" 
      justifyContent="center" 
      minHeight="80vh"
    >
      <Typography variant="h4" gutterBottom>
        Payment received
      </Typography>
      <Typography variant="body1" gutterBottom>
        Redirecting to credits and billing...
      </Typography>
      <CircularProgress style={{ marginTop: '20px' }} />
    </Box>
  );
};

export default PaymentSuccess;
